const activeCardsSection = {
  activeCards: {
    auto: 'Empréstimo com Veículo',
    home: 'Empréstimo com Imóvel',
    details: 'Veja mais detalhes sobre a sua proposta',
  },
};

export { activeCardsSection };
